import { h } from 'vue'
import Icon from '@teams/common/components/icon'
import { GlobalIconConfig } from 'naive-ui'

// NOTE: 由于Icon组件默认size：16px，所以替换后，某些组件的StatusIcon也会变成16px，有可能导致样式异常。
// 影响面：https://kdocs.cn/l/cvbikh5AJtXQ?linkname=niUspQNkCv
export const statusIcons: GlobalIconConfig = {
  info: () => h(Icon, { name: 'info', size: 16 }),
  success: () => h(Icon, { name: 'success', size: 16 }),
  warning: () => h(Icon, { name: 'warn', size: 16 }),
  error: () => h(Icon, { name: 'error', size: 16 })
}
